import '../App.css';
import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import AuthRoute from './AuthRoute';
import AppRoute from './AppRoute';
import { LINK_PATH } from '../constant';
import { closeAllModals, savePageFocus } from '../redux/actions/action-creator';
import useAutoDateUpdate from '../components/Custom_Hooks/useAutoDateUpdate';

const Index = () => {
  const { id } = useParams()
  const dispatch = useDispatch();
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const location = useLocation();
  const navigate = useNavigate();

  // Auto update current date
  useAutoDateUpdate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // List of shortcuts to disable
      if (event.altKey) {
        event.preventDefault();
      } else if (event.ctrlKey && (event.key === 't' || event.key === 'T')) {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'r') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'n') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'p') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'w') {
        event.preventDefault();
      }
      // else if (event.ctrlKey && event.key === 'a') {
      //   event.preventDefault();
      // }
      //  else if (event.ctrlKey && event.key === 'c') {
      //   event.preventDefault();
      // } 
      else if (event.ctrlKey && (event.key === '=' || event.key === '+')) {
        // event.preventDefault();
      } else if (event.ctrlKey && (event.key === '_' || event.key === '-')) {
        // event.preventDefault();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        // if (location.pathname !== `/`) {
        //   navigate(-1);
        // }

        if (Object?.values(modal_state)?.includes(true)) {
          dispatch(closeAllModals());
        }
        else
          if (location.pathname !== '/') {
            navigate(-1);
          }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate, location.pathname, modal_state, dispatch]);

  useEffect(() => {
    const handleFocus = (event) => {
      if (event.target.id) {
        dispatch(savePageFocus(location.pathname, event.target.id));
      }
    };
    window.addEventListener('focusin', handleFocus);
    return () => window.removeEventListener('focusin', handleFocus);
  }, [location.pathname, dispatch]);

  const page_history = useSelector(state => state.common.page_history || {});

  useEffect(() => {
    const currentHistory = page_history?.[location.pathname];
    if (currentHistory?.focusId) {
      setTimeout(() => {
        const element = document.getElementById(currentHistory.focusId);
        if (element && element !== document.activeElement) {
          element.focus();
          if (element.select) element.select();
        }
      }, 100);
    }
  }, [location.pathname, page_history]);

  useEffect(() => {
    const changeTitleName = () => {
      const path = location.pathname;
      if (path === '/') {
        if (userData?.id) {
          document.title = 'eBalance | Home';
        } else {
          document.title = 'eBalance | Login';
        }
      } else if (path === '/signUp') {
        document.title = 'eBalance | Sign Up';
      } else if (path === '/branch_login') {
        document.title = 'eBalance | Branch Login';
      } else if (path === '/createmasters') {
        document.title = 'Create Master';
      } else if (path === '/create-master-group') {
        document.title = 'Group Creation';
      }
      else if (path === '/create-master-ledger') {
        document.title = 'Ledger Creation';
      }
      else if (path === '/chart-of-account-accounting-master-group') {
        document.title = 'List of Group(s)';
      }
      else if (path === `/alter_accounting_groupupdate/${id}`) {
        document.title = 'Group Alteration';
      }
      else if (path === `/chart-of-account-accounting-master-voucherstype`) {
        document.title = 'List of Voucher Type(s)';
      }

      else if (path === `/create-master-invmas-stockcompany`) {
        document.title = 'Stock Company Creation';
      }
      else if (path === `/create-master-invmas-stockcategory`) {
        document.title = 'Stock Category Creation';
      }
      else if (path === `/create-master-invmas-stockgroup`) {
        document.title = 'Stock Group Creation';
      }
      else if (path === `/chart-of-account-invmas-stockgroup`) {
        document.title = 'List of Stock Group';
      }
      else if (path === `/chart-of-account-invmas-stockcategory`) {
        document.title = 'List of Stock Category';
      }
      else if (path === `/chart-of-account-invmas-stockcompany`) {
        document.title = 'List of Stock Company';
      }
      else if (path === `/chart-of-account-invmas-stockitem`) {
        document.title = 'List of Stock Items';
      }
      else if (path === `/chart-of-account-invmas-unit`) {
        document.title = 'List of Stock Units';
      }
      else if (path === `/chart-of-account-invmas-godown`) {
        document.title = 'List of Stock Godowns';
      }
      else if (path === `/chartofaccountmasters`) {
        document.title = 'Master List';
      }
      else if (path === `/chart-of-account-accounting-master-ledger`) {
        document.title = 'List of Ledger(s)';
      }
      else if (path === `/stocksummary`) {
        document.title = 'Stock Summary';
      }
      else {
        document.title = 'Accounting';
      }
    };
    changeTitleName();
    dispatch(closeAllModals());
    return () => {
    };
  }, [location, userData, id]);

  useEffect(() => {
    // Define allowed routes for users without authentication
    const allowedUnauthenticatedRoutes = ['/', '/signUp', '/branch_login'];

    if (!userData?.id) {
      // If user is not authenticated and trying to access a restricted route
      if (!allowedUnauthenticatedRoutes.includes(location.pathname)) {
        return navigate('/');
      }
    }
  }, [userData, location.pathname, navigate]);

  return (
    <div className="App">
      <Routes>
        {
          userData?.id
            ?
            <Route path={`${LINK_PATH}/*`} element={<AppRoute />} />
            :
            <Route path={`${LINK_PATH}/*`} element={<AuthRoute />} />
        }
      </Routes>
    </div>
  )
}
export default Index;
